function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M15.75 0.749512H8.25C7.00736 0.749512 6 1.75687 6 2.99951V20.9995C6 22.2421 7.00736 23.2495 8.25 23.2495H15.75C16.9926 23.2495 18 22.2421 18 20.9995V2.99951C18 1.75687 16.9926 0.749512 15.75 0.749512Z",
  stroke: "#8C30F5",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M8.25 0.749512H9.375C9.47446 0.749512 9.56984 0.789021 9.64016 0.859347C9.71049 0.929673 9.75 1.02506 9.75 1.12451C9.75 1.32342 9.82902 1.51419 9.96967 1.65484C10.1103 1.79549 10.3011 1.87451 10.5 1.87451H13.5C13.6989 1.87451 13.8897 1.79549 14.0303 1.65484C14.171 1.51419 14.25 1.32342 14.25 1.12451C14.25 1.02506 14.2895 0.929673 14.3598 0.859347C14.4302 0.789021 14.5255 0.749512 14.625 0.749512H15.75",
  stroke: "#8C30F5",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.cd8d5c4c.svg";
export { ForwardRef as ReactComponent };